import type { JSX } from 'react';
import { useMsal } from '@azure/msal-react';
import { LogIn } from 'lucide-react';
import { loginRequest } from '@/auth/msal-config';

// EW-190: where logout lands. Renders outside the admin shell on purpose — a sidebar full
// of admin links is exactly what a signed-out visitor must not see. This is also the only
// screen that offers a login button, since every other route redirects before rendering.
export function LoggedOut(): JSX.Element {
  const { instance } = useMsal();

  return (
    <div className="flex h-screen items-center justify-center bg-background p-6">
      <div className="card w-full max-w-sm bg-card p-8 text-center">
        <h1 className="text-lg font-medium text-heading">Sikeres kilépés</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          A felület megtekintéséhez bejelentkezés szükséges.
        </p>
        <button className="btn-action mt-6" onClick={() => void instance.loginRedirect(loginRequest)}>
          <LogIn className="h-4 w-4" /> Bejelentkezés
        </button>
      </div>
    </div>
  );
}
